import { prepareFilter } from '../redux/actions';
import prepareDetails from '../helpers/prepareDetails';
import axios from './axios';

class Transactions {

    /*
    getTickets = async (searchParams, filterSelected, filterData, Details) => {
        const response = await axios.put(`transactions/filterbymachine2/`, this.prepareData(searchParams, filterSelected, filterData, Details));
        return response.data;
    }

    getKiosk = async (searchParams, filterSelected, filterData, Details) => {

    }*/
    getSummary = async (searchParams, filterSelected, filterData, Details) => {
        const response = await axios.put(`Transactions/byOrg/summary`, this.prepareData(searchParams, filterSelected, filterData, Details));
        return response.data;
    }

    getTransactions = async (searchParams, filterSelected, filterData, Details, pageNumber) => {
        const response = await axios.put(`Transactions/byOrg/filter`, this.prepareData(searchParams, filterSelected, filterData, Details, pageNumber));
        return response.data;
    }

    prepareData = (searchParams, filterSelected, filterData, Details, pageNumber) => {
        const { operator, company, subcompany, site } = filterSelected;
        return { 
            // Search params
            StartDate: searchParams.startDate, 
            EndDate: searchParams.endDate, 
            IncludeEvents: searchParams.includeEvents || false,
            SessionId: parseInt(searchParams.sessionId) || -1,
            TransactionRef: searchParams.transactionRef || "#",
            AssetNo: searchParams.assetNo || "#", 
            PlayerId: searchParams.playerId || "#", 
            pageNumber,

            // Selected company etc from the org tree
            OperatorId: operator, 
            CompanyId: company.id || -1, 
            SubCompanyId: subcompany.id || -1,
            SiteId: site.id || -1, 

            // Selected filters from the org tree
            OperatorRegions: prepareFilter(filterSelected.regions, filterData.regions),
            Manufacturers: prepareFilter(filterSelected.manufacturer, filterData.manufacturer),
            GameNames: prepareFilter(filterSelected.game, filterData.game),
            Categories: prepareFilter(filterSelected.machinetypes, filterData.machinetypes),

            // Filters from the summary;
            Details: prepareDetails(Details),
        }
    }

}

export default new Transactions();
